export default "__VITE_ASSET__BczwlDhy__"